import { widgetStateToggleUrlParam } from 'constants/general';
import { KeyAstromTarget } from 'enums/AnalyticsTarget';
import { ChatHistoryURL } from 'enums/ChatHistoryURL';
import { StorageKey } from 'enums/StorageKey';
import { DefaultRootState } from 'react-redux';

import { DtrumUtils } from './analytics/dtrumsutils';
import { ChatPerfomance } from './dtrum';
import { Navigate } from './navigate';
import { widgetStore } from './widgetStore';

export class ChatStateController {
    static isChatInitialized;
    static isPreventClosingEnabled;

    private static getWasChatOpened() {
        if (Navigate.getIsRoutingEnabled()) {
            return typeof window.history.state?.chatOpened !== 'undefined';
        }

        return Boolean(localStorage.getItem(StorageKey.ChatOpened));
    }

    private static getStateValue(chatOpened: boolean) {
        return {
            chatOpened,
        };
    }

    private static get isChatOpen() {
        return history.state?.chatOpened ?? false;
    }

    private static openChat() {
        Navigate.navigate({
            params: { [widgetStateToggleUrlParam]: 1 },
            state: this.getStateValue(true),
            replace: false,
        });
    }

    private static closeChat() {
        const open = !!(widgetStore.store?.getState() as DefaultRootState)?.chat.open;

        if (open) {
            this.clearQueryParams();
        }
    }

    private static initializeChatState() {
        if (Navigate.getIsRoutingEnabled()) {
            // https://github.com/whatwg/html/issues/7832#issue-1207220491
            Navigate.updateQueryParams({
                params: [widgetStateToggleUrlParam],
                state: this.getStateValue(false),
                replace: false,
            });
        } else {
            localStorage.setItem(StorageKey.ChatOpened, 'true');
        }
    }

    public static toggleChat(shouldOpenChat: boolean) {
        if (!this.getWasChatOpened()) {
            this.initializeChatState();
        }

        if (shouldOpenChat) {
            DtrumUtils.startAction(KeyAstromTarget.BUTTONCLICK_HISTORY_LOAD_DElAY);
            ChatPerfomance.setClicked();
            return this.openChat();
        }

        if (!this.isPreventClosingEnabled) {
            return this.closeChat();
        }
    }

    public static pushChatView(param: ChatHistoryURL) {
        Navigate.changeQueryParams({
            params: { [param]: 1 },
            state: this.getStateValue(false),
            isAppend: true,
        });
    }

    public static goToPrevChatView(param: ChatHistoryURL) {
        Navigate.changeQueryParams({
            params: { [param]: 1 },
            state: this.getStateValue(false),
            replace: true,
        });
    }

    public static clearQueryParams() {
        Navigate.changeQueryParams({
            params: {
                [widgetStateToggleUrlParam]: 1,
                [ChatHistoryURL.WidgetMenuToggleUrlParam]: 1,
                [ChatHistoryURL.WidgetMediaGalleryPhotoExpandedToggleUrlParam]: 1,
            },
            state: this.getStateValue(false),
            replace: true,
        });
    }
}
